import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { purple, primaryGradient, transition, getGlowBorder } from './glowUtil'
import { DOT_PREFIX } from './constant'

export const genStyle = (token: FullToken) => {
  const { componentCls, lineWidth } = token

  return {
    [`${DOT_PREFIX}${componentCls}-wrapper`]: {
      [componentCls]: {
        transition,
        '&:before': [
          ...getGlowBorder(lineWidth),
          { inset: 0, opacity: 1 },
        ],
        '&:hover:before': {
          background: `${purple[500]}40`,
        },
        [`&${componentCls}-checked ${componentCls}-inner`]: {
          background: `${primaryGradient} !important`,
          boxShadow: `0 0 6px ${purple[500]}40`,
        },
      },
      '&-disabled': {
        [componentCls]: {
          '&:before': { opacity: 0.3 },
        },
      },
    },
  }
}

export default genComponentStyleHook(['Checkbox', 'heroTheme'], (token: FullToken) => {
  return [genStyle(token)]
})
